import { render, staticRenderFns } from "./GenericCheckboxGroup.vue?vue&type=template&id=c47b9f68&"
import script from "./GenericCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./GenericCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports